<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-ever">Message List</h2>
      <base-button
        type="primary"
        class="top-button"
        @click="$router.push('send')"
      >
        <i class="fa fa-plus"></i> Send a Message
      </base-button>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Message List</h4>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

            </div>
            <el-table :data="queriedData">
              <el-table-column
                :min-width="200"
                align="left"
                label="Message"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div class="text-muted">
                        Sent: {{ formatDateTime(props.row.created_at) }}
                      </div>
                      <div>Subject: {{ props.row.subject }}</div>
                      <div>
                        Message: {{ props.row.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="200"
                align="left"
                label="Expires"
              >
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.expires_on ? formatDateTime(props.row.expires_on) : "n/a" }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Important">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.important ? 'yes' : 'no' }}</div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Control">
                <div slot-scope="props">
                  <button
                    class="btn btn-fill"
                    @click="deleteMessage(props.row._id)"
                  >
                    Delete
                  </button>
                </div>
              </el-table-column>


            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>

  </div>
</template>

<script>

import moment from "moment";
import {BaseAlert, BasePagination, Modal} from "@/components";
import {Option, Select, Table, TableColumn} from "element-ui";
import Fuse from "fuse.js";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },

  data() {
    return {
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: [],
      tableColumns: [
        {
          prop: "subject",
          label: "Subject",
          minWidth: 200,
        },
        {
          prop: "message",
          label: "Message",
          minWidth: 250,
        },
        {
          prop: "important",
          label: "Important",
          minWidth: 100,
        },
        {
          prop: "expires",
          label: "Expires",
          minWidth: 120,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {},
    };
  },

  async mounted() {
    this.loading = true;
    let messages = await this.$apiService.getCall("message/messages");
    messages = messages.apidata.Data || [];
    this.tableData =  messages;
    this.loading = false;
  },

  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  methods: {
    formatDateTime(datetime) {
      return moment(datetime).format('MM-DD-YYYY HH:mm')
    },

    async deleteMessage(id) {
      let confirmed = confirm("Are you sure you want to delete this message? It'll delete it from all users.");
      if (confirmed === true) {
        this.loading = true;
        let message = await this.$apiService.postCall(`message/delete/${id}`);
        if(message.apidata.Data && message.apidata.Data._id) {
          this.tableData = this.tableData.filter((item) => item._id !== id);
          await this.$apiService.notify("The message was deleted successfully!");
        } else {
          await this.$apiService.notify("Something went wrong. Please contact support.");
        }
        this.loading = false;
      }
    }
  }
};
</script>
